import { Search } from 'lucide-react';
import { useSearchStore, type Scope } from './searchStore';
import './Search.css';

/**
 * The way into search that isn't a keystroke.
 *
 * It sits beside the heading rather than in the row of buttons opposite,
 * because searching is a thing you do *to* what the heading names — this room,
 * or all of them — and the two controls over there make new things.
 *
 * Quiet by default: `--stone`, no fill, no border. A wall of photographs
 * shouldn't be competing with a magnifying glass.
 */
export function SearchButton({ scope, label }: { scope: Scope; label: string }) {
  const openSearch = useSearchStore((state) => state.openSearch);

  return (
    <button
      type="button"
      className="search-button"
      aria-label={label}
      onClick={() => openSearch(scope)}
    >
      <Search size={18} aria-hidden />
    </button>
  );
}
